import { n1, STATS, STAT_LABEL } from "@/lib/format";

export function ProjectionTiles({ projection, seasonAvg, seasonLabel, minGames, actual }) {
  if (actual) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-testid="final-tiles">
        {STATS.map((s) => (
          <div key={s} data-testid={`final-tile-${s}`} className="rounded-lg border border-slate-800 bg-[#1A2130] p-5">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">{STAT_LABEL[s]} · Final</div>
            <div className="text-4xl font-extrabold tracking-tighter font-mono-num text-slate-50 mt-2">{actual[s]}</div>
            {projection && <div className="text-xs text-slate-500 mt-3 font-mono-num">Pregame projection {n1(projection[s].proj)}</div>}
          </div>
        ))}
      </div>
    );
  }
  if (!projection) {
    return (
      <div data-testid="projection-unavailable" className="rounded-lg border border-amber-700/40 bg-amber-950/20 p-5 text-amber-200 text-sm">
        No projection: needs an upcoming game and at least {minGames} stored games.
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      {STATS.map((s, i) => {
        const p = projection[s];
        const avg = seasonAvg?.[s];
        const diff = avg != null ? p.proj - avg : null;
        return (
          <div key={s} data-testid={`tile-${s}`} style={{ animationDelay: `${i * 60}ms` }}
            className="fade-up rounded-lg border border-slate-800 bg-[#1A2130] p-5 hover:border-blue-500/50 transition-colors">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">{STAT_LABEL[s]}</div>
            <div className="text-4xl font-extrabold tracking-tighter font-mono-num text-slate-50 mt-2">{n1(p.proj)}</div>
            <div className="inline-flex items-center gap-1.5 mt-2 px-2.5 py-1 rounded-md bg-blue-950/60 border border-blue-500/30 text-blue-300 text-xs font-mono-num font-semibold">
              80% {n1(p.low)}–{n1(p.high)}
            </div>
            <div className="text-xs text-slate-500 mt-3 font-mono-num">
              {seasonLabel} avg {n1(avg)}{diff != null && <span className={diff >= 0 ? "text-emerald-400" : "text-rose-400"}> {diff >= 0 ? "+" : ""}{n1(diff)}</span>}
              <span className="block">sd {n1(p.sd)}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
